<template>
  <div class="full-screen" style="z-index: 8;">
    <top id="top-nav" :title="bookTitle" :key="`${bookTitle}-catalog`"></top>
    <div class="main" style="height: calc(100% - 2rem); overflow: auto; padding-top: 2rem;"  @scroll="handleScroll">
      <div class="">
        <ul class="chapterlist">
          <li v-for="(item, index) in catalog" :key="index">
            <a class="flex" @click="toChapter(item.bookId, item.number)">

              <div class="right">
                <div class="clearfix">
                  <span class="fl">{{item.title}}</span>
                  <span class="fr">
									  <span :class="getPriceTextClass(item)">{{getPriceText(item.price, item.alreadyBuy)}}</span>
								  </span>
                </div>
                <template v-if="history.number == item.number">
                  <span  class="bg-red">上次阅读</span>
                </template>

              </div>
            </a>
          </li>
          <div class="c-loading" v-show="loading">加载中...</div>
          <div class="c-finished" v-show="finished">没有更多了！</div>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import novelService from '../../../services/novelService'
import shelfService from '../../../services/shelfService'
import BookTop from '@/components/layer2/book/book-top'

export default {
  name: 'catagory',
  data () {
    return {
      loading: false,
      finished: false,
      finishedText: '',
      list: [],
      currentPage: 1,
      bookId: '',
      history: {},
      catalog: [],
      bookTitle: '',
    }
  },
  methods: {

      getHistory (bookId) {
        this.history = shelfService.getHistoryById(parseInt(bookId)) || {}
      },

      handleScroll(e){
        const {scrollTop, clientHeight, scrollHeight} = e.target
        if((scrollTop + clientHeight + 1 >= scrollHeight) && !this.loading && !this.finished){
          this.getCatalog()
        }
      },

      getCatalog() {
        const { currentPage, finished, list, bookId } = this
        this.loading = true
        if (finished) return
        novelService.getChapters(bookId, currentPage).then(res => {
          this.loading = false
          const resData = res.data || {}
          const chapters = resData.chapters || []
          this.catalog = this.catalog.concat(chapters)
          if (currentPage >= resData.totalPage || chapters.length === 0) {
            this.finished = true
          } else {
            this.currentPage++
          }
          this.loading = false
        })
      },

      getPriceText(price, alreadyBuy) {
        if (alreadyBuy) {
          return '已购买'
        }
        if (price === 0 || price === '0') {
          return '免费'
        } else {
          return `${price} 金币`
        }
      },

      getPriceTextClass(item) {
        if (item.alreadyBuy){
          return "c3";
        }
        if (item.price == 0){
          return "c1";
        }else {
          return "c2";
        }
      },

      toChapter (bookId, number) {
        this.$router.isBack = false;
        this.$router.push({
          path: `/novels/read/${bookId}/${number}`,
          query: {
            title: this.$route.query.title,
            title2: this.catalog.find(item => item.number === number).title
          }
        })
      },

  },
  components: {
    top: BookTop
  },
  mounted () {
    const bookId = this.$route.params.id
    this.bookId = bookId
    this.bookTitle = this.$route.query.title
    this.getHistory(bookId)
    this.getCatalog()
    this.$router.isBack = true
  }
}
</script>

<style scoped>
.c-loading, .c-finished{ height: 2rem; line-height: 2rem; text-align: center; color: #aca683; width: 100%; font-size: .8rem;}
.c-finished{ color: #c17a51; font-size: .6rem;}
.chapterlist li .right .fl{padding-top: .3rem;}
.chapterlist li .right .c1{ margin-top: .5rem;}
.chapterlist li .right .c2{ margin-top: .5rem;}
.chapterlist li .right .c3{ margin-top: .5rem;}
.bg-red{ background: #c17a51; color: #fff; font-size: .6rem; padding: .1rem .5rem; border-radius: .5rem;}
</style>



// WEBPACK FOOTER //
// src/pages/layer2/novels/catalog.vue